import { render, staticRenderFns } from "./HelpCenterBtn.vue?vue&type=template&id=6acb4f74&"
import script from "./HelpCenterBtn.vue?vue&type=script&lang=js&"
export * from "./HelpCenterBtn.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterBtn.vue?vue&type=style&index=0&id=6acb4f74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports